export default __webpack_public_path__ + "static/media/Ballroll_00150.c1c107d2.png";